import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdiantamentoEditarComponent } from './adiantamento-editar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: AdiantamentoEditarComponent}
  ])],
  exports: [RouterModule]
})
export class AdiantamentoEditarRoutingModule { }
